/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3dPb } from "../../../../gen/eigen_lcm/Vector3d";

export const protobufPackage = "skills";

/** NOTE(nathan): This currently only changes the spoofed VIO state estimate */
export interface ModifySimStateEstimationActionArgs {
  /**
   * Modifies the estimated vehicle position by the given offset. Can be used to spoof sudden jumps
   * in the estimated vehicle position.
   */
  positionOffset:
    | Vector3dPb
    | undefined;
  /**
   * Modifies the estimated vehicle velocity by the given offset. This should not affect the
   * vehicle position estimate, so by setting this to a nonzero value the spoofed state estimate
   * will no longer be kinematically consistent (i.e. position is not the integral of velocity).
   */
  velocityOffset: Vector3dPb | undefined;
}

export interface ModifySimStateEstimationResultData {
}

export interface ModifySimStateEstimationActionStateData {
}

function createBaseModifySimStateEstimationActionArgs(): ModifySimStateEstimationActionArgs {
  return { positionOffset: undefined, velocityOffset: undefined };
}

export const ModifySimStateEstimationActionArgs = {
  encode(message: ModifySimStateEstimationActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.positionOffset !== undefined) {
      Vector3dPb.encode(message.positionOffset, writer.uint32(10).fork()).ldelim();
    }
    if (message.velocityOffset !== undefined) {
      Vector3dPb.encode(message.velocityOffset, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ModifySimStateEstimationActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifySimStateEstimationActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.positionOffset = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.velocityOffset = Vector3dPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModifySimStateEstimationActionArgs {
    return {
      positionOffset: isSet(object.positionOffset) ? Vector3dPb.fromJSON(object.positionOffset) : undefined,
      velocityOffset: isSet(object.velocityOffset) ? Vector3dPb.fromJSON(object.velocityOffset) : undefined,
    };
  },

  toJSON(message: ModifySimStateEstimationActionArgs): unknown {
    const obj: any = {};
    if (message.positionOffset !== undefined) {
      obj.positionOffset = Vector3dPb.toJSON(message.positionOffset);
    }
    if (message.velocityOffset !== undefined) {
      obj.velocityOffset = Vector3dPb.toJSON(message.velocityOffset);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifySimStateEstimationActionArgs>, I>>(
    base?: I,
  ): ModifySimStateEstimationActionArgs {
    return ModifySimStateEstimationActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifySimStateEstimationActionArgs>, I>>(
    object: I,
  ): ModifySimStateEstimationActionArgs {
    const message = createBaseModifySimStateEstimationActionArgs();
    message.positionOffset = (object.positionOffset !== undefined && object.positionOffset !== null)
      ? Vector3dPb.fromPartial(object.positionOffset)
      : undefined;
    message.velocityOffset = (object.velocityOffset !== undefined && object.velocityOffset !== null)
      ? Vector3dPb.fromPartial(object.velocityOffset)
      : undefined;
    return message;
  },
};

function createBaseModifySimStateEstimationResultData(): ModifySimStateEstimationResultData {
  return {};
}

export const ModifySimStateEstimationResultData = {
  encode(_: ModifySimStateEstimationResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ModifySimStateEstimationResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifySimStateEstimationResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ModifySimStateEstimationResultData {
    return {};
  },

  toJSON(_: ModifySimStateEstimationResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifySimStateEstimationResultData>, I>>(
    base?: I,
  ): ModifySimStateEstimationResultData {
    return ModifySimStateEstimationResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifySimStateEstimationResultData>, I>>(
    _: I,
  ): ModifySimStateEstimationResultData {
    const message = createBaseModifySimStateEstimationResultData();
    return message;
  },
};

function createBaseModifySimStateEstimationActionStateData(): ModifySimStateEstimationActionStateData {
  return {};
}

export const ModifySimStateEstimationActionStateData = {
  encode(_: ModifySimStateEstimationActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ModifySimStateEstimationActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifySimStateEstimationActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ModifySimStateEstimationActionStateData {
    return {};
  },

  toJSON(_: ModifySimStateEstimationActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifySimStateEstimationActionStateData>, I>>(
    base?: I,
  ): ModifySimStateEstimationActionStateData {
    return ModifySimStateEstimationActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifySimStateEstimationActionStateData>, I>>(
    _: I,
  ): ModifySimStateEstimationActionStateData {
    const message = createBaseModifySimStateEstimationActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
